<template>
    <div>
      <b-button variant="info" @click="showModal = true">
        Mostra Legenda
      </b-button>
      <b-modal v-model="showModal" hide-footer modal-class="zoomIn" centered>
        <div class="text-center">
          <h5 class="legend-title">Legenda Icone</h5>
          <b-row>
            <b-col v-for="(item, index) in iconList" :key="index" cols="6" class="legend-item">
              <img :src="item.icon" :alt="item.label" class="legend-icon" />
              <span>{{ item.label }}</span>
            </b-col>
          </b-row>
        </div>
        <div class="text-center">
          <b-button variant="info" @click="showModal = false">Chiudi</b-button>
        </div>
      </b-modal>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      iconList: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        showModal: false,
      };
    },
  };
  </script>
  
  <style scoped>
  .legend-title {
    font-weight: bold;
    margin-bottom: 30px;
  }
  
  .legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .legend-icon {
    width: 20px;
    height: 20px;
    margin-right: 9px;
  }

  </style>
  